// extracted by mini-css-extract-plugin
export default {"configuration":"style_configuration__XoPa+","configurationFieldSet":"style_configurationFieldSet__ECxIN","configurationLegend":"style_configurationLegend__iNtKw"};